// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"366":"5df847dd","487":"49a34ceb"}[chunkId] + ".chunk.css";
};